<template>
    <div id="plan-form" v-if="user.global_admin">
        <div class="container-fluid">
            <div class="box row">
                <div class="field col-12 mb-3">
                    <label>{{ t('plans-form-name') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.name"
                    />
                </div>
                <div class="field col-12 mb-3">
                    <label>{{ t('plans-form-description') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.description"
                    />
                </div>
                <div class="field col-12 mb-3">
                    <label>{{ t('plans-form-currency') }}</label>
                    <select class="form-control" v-model="form.currency">
                        <option value="BRL">{{ t('plans-form-currency_brl') }}</option>
                        <option value="USD">{{ t('plans-form-currency_usd') }}</option>
                    </select>
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-billing_type') }}</label>
                    <select
                        class="form-control"
                        type="text"
                        v-model="form.billing_type"
                        @change="onBillingTypeChange"
                    >
                        <option value="prepaid">{{ t('plans-form-prepaid') }}</option>
                        <option value="postpaid">{{ t('plans-form-postpaid') }}</option>
                    </select>
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-base_value') }}</label>
                    <input
                        class="form-control"
                        type="number"
                        v-model="form.base_fee"
                    />
                </div>
                <div
                    class="field col-12 mb-3"
                    v-if="form.billing_type === 'postpaid'"
                >
                    <label class="d-flex align-items-center mb-1" style="cursor: pointer;">
                        <input
                            type="checkbox"
                            v-model="form.one_invoice_per_branch_plus_base"
                            style="margin: 0 8px 0 0; cursor: pointer; width: 16px; height: 16px; flex-shrink: 0;"
                        />
                        <span>{{ t('plans-form-one_invoice_per_branch_plus_base') }}</span>
                    </label>
                    <small class="form-text text-muted" style="margin-top: 0; margin-left: 24px;">
                        {{ t('plans-form-one_invoice_per_branch_plus_base_help') }}
                    </small>
                </div>
                <div
                    class="field col-6 mb-3"
                    v-if="form.billing_type === 'postpaid'"
                >
                    <label>{{ t('plans-form-incentivized_revenue_share') }}</label>
                    <input
                        class="form-control"
                        type="number"
                        v-model="form.incentivized_revenue_share"
                    />
                </div>
                <div
                    class="field col-6 mb-3"
                    v-if="form.billing_type === 'postpaid'"
                >
                    <label>{{ t('plans-form-retention_revenue_share') }}</label>
                    <input
                        class="form-control"
                        type="number"
                        v-model="form.retention_revenue_share"
                    />
                </div>
                <div class="field col-12 mb-3">
                    <label>{{ t('plans-form-pricetable_clients') }}</label>
                    <PriceTable v-model="form.pricetable_clients" :currency="form.currency"/>
                </div>
                <div class="field col-12 mb-3">
                    <label>{{ t('plans-form-pricetable_credits') }}</label>
                    <PriceTable v-model="form.pricetable_credits" :currency="form.currency"/>
                </div>
                <div
                    class="field col-12 mb-3"
                    v-if="form.billing_type === 'prepaid'"
                >
                    <label>{{ t('plans-form-pricetable_extra_credits') }}</label>
                    <PriceTable v-model="form.pricetable_extra_credits" />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-included_integrations') }}</label>
                    <input
                        class="form-control"
                        type="number"
                        v-model="form.included_integrations"
                    />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-price_per_integration') }}</label>
                    <input
                        class="form-control"
                        type="number"
                        v-model="form.price_per_integration"
                    />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-included_branches') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.included_branches"
                    />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-price_per_branch') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.price_per_branch"
                    />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-included_users') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.included_users"
                    />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-price_per_user') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.price_per_user"
                    />
                </div>
                <div class="field col-6 mb-3">
                    <label>{{ t('plans-form-included_users_per_branch') }}</label>
                    <input
                        class="form-control"
                        type="text"
                        v-model="form.included_users_per_branch"
                    />
                </div>
                <div class="field col-12 mb-3 mt-4">
                    <h5 class="m-0 font-weight-bold" style="font-size: 1.1rem; margin-bottom: 10px !important;">{{ t('plans-form-readjustment-title') }}</h5>
                    <label>{{ t('plans-form-readjustment-percentage') }}</label>
                    <div class="input-group">
                        <input type="number" step="0.01" class="form-control" v-model="readjustment_percentage" :placeholder="t('plans-form-readjustment-placeholder')" />
                        <div class="input-group-append">
                            <button class="btn btn-dark" style="background-color: #0f172a; border-color: #0f172a;" @click.prevent="applyReadjustment">
                                {{ t('plans-form-readjustment-apply') }}
                            </button>
                        </div>
                    </div>
                    <small class="form-text text-muted mt-2">{{ t('plans-form-readjustment-help') }}</small>
                </div>

                <DiscountTable v-model="form.discounts" :currency="form.currency" />

                <div class="col-12">
                    <div class="pull-right">
                        <button class="btn btn-primary" @click.prevent="save">
                            {{ t('plans-form-save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import PriceTable from "./priceTable.vue";
import DiscountTable from "./discountTable.vue";
export default {
    props: {
        user: Object,
        plugin: String,
    },
    components: {
        PriceTable,
        DiscountTable,
    },
    data: () => ({
        id: null,
        readjustment_percentage: null,
        form: {
            name: null,
            description: null,
            billing_type: null,
            base_fee: null,
            currency: "BRL",
            incentivized_revenue_share: null,
            retention_revenue_share: null,
            pricetable_clients: [],
            pricetable_credits: [],
            pricetable_extra_credits: [],
            included_integrations: null,
            price_per_integration: null,
            included_branches: null,
            price_per_branch: null,
            included_users: null,
            price_per_user: null,
            included_users_per_branch: null,
            one_invoice_per_branch_plus_base: false,
            discounts: [],
        },
    }),
    mounted() {
        this.id = this.$route.params.id;
        if (this.id) {
            this.loadData();
        }
    },
    methods: {
        onBillingTypeChange() {
            if (this.form.billing_type === "postpaid" && !this.id) {
                this.form.one_invoice_per_branch_plus_base = true;
            }
        },
        async loadData() {
            let options = keviApi.getOptions("plans/" + this.id, "GET");
            this.$http(options).then((response) => {
                this.form.name = response.body.plan.name;
                this.form.description = response.body.plan.description;
                this.form.billing_type = response.body.plan.billing_type;
                this.form.base_fee = response.body.plan.base_fee;
                this.form.currency = response.body.plan.currency || "BRL";
                this.form.incentivized_revenue_share =
                    response.body.plan.incentivized_revenue_share;
                this.form.retention_revenue_share =
                    response.body.plan.retention_revenue_share;
                this.form.pricetable_clients =
                    response.body.plan.pricetable_clients;
                this.form.pricetable_credits =
                    response.body.plan.pricetable_credits;
                this.form.pricetable_extra_credits =
                    response.body.plan.pricetable_extra_credits;
                this.form.included_integrations =
                    response.body.plan.included_integrations;
                this.form.price_per_integration =
                    response.body.plan.price_per_integration;
                this.form.included_branches =
                    response.body.plan.included_branches;
                this.form.price_per_branch =
                    response.body.plan.price_per_branch;
                this.form.included_users = response.body.plan.included_users;
                this.form.price_per_user = response.body.plan.price_per_user;
                this.form.included_users_per_branch = response.body.plan.included_users_per_branch;
                this.form.one_invoice_per_branch_plus_base =
                    Number(response.body.plan.one_invoice_per_branch_plus_base) === 1;
                this.form.discounts = response.body.plan.discounts || [];
            });
        },
        applyReadjustment() {
            const percentage = parseFloat(this.readjustment_percentage);
            if (isNaN(percentage) || percentage === 0) return;
            
            const multiplier = 1 + (percentage / 100);

            const adjustValue = (val) => {
                if (val !== null && val !== "" && !isNaN(val)) {
                    return parseFloat((parseFloat(val) * multiplier).toFixed(2));
                }
                return val;
            };

            this.form.base_fee = adjustValue(this.form.base_fee);
            this.form.price_per_integration = adjustValue(this.form.price_per_integration);
            this.form.price_per_branch = adjustValue(this.form.price_per_branch);
            this.form.price_per_user = adjustValue(this.form.price_per_user);

            const adjustTable = (table) => {
                if (table && table.length > 0) {
                    return table.map(row => ({
                        ...row,
                        unitValue: adjustValue(row.unitValue)
                    }));
                }
                return table;
            };

            this.form.pricetable_clients = adjustTable(this.form.pricetable_clients);
            this.form.pricetable_credits = adjustTable(this.form.pricetable_credits);
            this.form.pricetable_extra_credits = adjustTable(this.form.pricetable_extra_credits);

            this.$store.dispatch(
                "notification/success",
                this.t("plans-form-readjustment-success", { percentage })
            );
        },
        async save() {
            const route = this.id ? "plans/edit/" + this.id : "plans/add";
            let options = keviApi.getOptions(route, "POST", { ...this.form });
            this.$http(options).then((response) => {
                this.$store.dispatch(
                    "notification/success",
                    this.t("plans-form-success_message"),
                );
            });
        },
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
